import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import MoneyMindUserDetail from './MoneyMindUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMoneyMindUserDetail } from './companyMoneyMindApi';

/**
 * Company MoneyMind → one employee's/member's usage profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CMoneyMindUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User MoneyMind Profile | Shoorah</title>
      </Helmet>
      <MoneyMindUserDetail
        fetcher={fetchCompanyMoneyMindUserDetail}
        backPath={`/${slug}/moneymind/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CMoneyMindUserDetail;
